import { useToasts } from '../../store/toast.ts';
import { IconClose } from '../../lib/icons.tsx';

export function ToastHost() {
  const toasts = useToasts((s) => s.toasts);
  const dismiss = useToasts((s) => s.dismiss);

  if (toasts.length === 0) return null;

  return (
    <div className="toasts" role="status" aria-live="polite">
      {toasts.map((t) => (
        <div key={t.id} className="toast" data-kind={t.kind}>
          <span className="truncate">{t.message}</span>
          {t.action && (
            <button className="btn btn--sm btn--ghost" onClick={t.action.run}>
              {t.action.label}
            </button>
          )}
          <button
            className="btn btn--sm btn--ghost btn--icon"
            aria-label="닫기"
            onClick={() => { dismiss(t.id); }}
          >
            <IconClose size={14} />
          </button>
        </div>
      ))}
    </div>
  );
}
